import React from 'react';
import BillingForm from './BillingForm';
import TchrOrderReview from '../../views/purchase/TchrOrderReview';
import $ from 'jquery';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import HmEventRegistry from '../../model/HmEventRegistry';

var paymentErrorMap = {
	"TXN_ERR_001": "Transaction not saved",
	"TXN_ERR_002":"Transaction failed",
	"TXN_ERR_003":"Field does not meet the minimum length",
	"TXN_ERR_004":"Field exceeds the maximum length",
	"TXN_ERR_005":"Space not allowed in the field",
	"TXN_ERR_006":"Should be Alphanumeric Only",
	"TXN_ERR_007":"Should contain Alphanumeric and permitted characters only",
	"TXN_ERR_008":"Should contain Alphabets Only",
	"TXN_ERR_009":"Should contain Numbers Only",
	"TXN_ERR_010":"Should contain Numbers and dot (.)",
	"TXN_ERR_011":"Contains Invalid Characters",
	"TXN_ERR_012":"Should contain Alpabets and characters only",
	"TXN_ERR_013":"Invalid parameter",
	"TXN_ERR_014":"Invalid Transaction amount",
	"TXN_ERR_015":"System Error"
};

export default class TchrBillingForm extends BillingForm{

    constructor(props){
        super(props)
        
        this.sessionId = null;
    }

    componentDidMount(){
        super.componentDidMount()
    }

     existingUserId(){
        return(
            <div>
                </div>
        )
    }

    newUserId(){
        return(
            <div>
                </div>
        ) 
    }

    setSessionId(sessionId){
        this.sessionId = sessionId;
    }

    submitForm = function(){
        this.userId = this.getUserId();

		var me =this;	
		var userExists = String(me.state.existing_userid);
		//console.log("userExists ==> ",userExists, "type : ",typeof userExists);
		//Setting payLoad
		//me.payload={"schoolId":me.purchaseObj.productCategory,"validTo":me.purchaseObj.validTo,"userName":me.state.billing_name,"userExists":userExists,"role":"TCHR","grade":"TCHR"};
		me.payload={"trackId":me.props.trackId};

		var payloadStr = JSON.stringify(me.payload);
		//abdul
		var formData = {
			userId:me.getUserId(),
			appName:this.purchaseObj.appName,
			_appId:this.purchaseObj.appId,
			sessionId:this.state.sessionId,
			fullName:this.state.billing_name,
			address:this.state.billing_address,
			zip:this.state.billing_zipcode,
			city:this.state.billing_city,
			state:this.state.billing_state, 		
			countryCode: this.state.selectedCountryOption.value || "",			
			country: this.state.selectedCountryOption.label || "",	
			email: this.state.billing_email,
			phone:this.state.billing_phone,
			language:'EN',
			productList:[{
			"productId":me.purchaseObj.productId,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
			}],
			currency:this.purchaseObj.currency,
			payload:payloadStr
		}

		var productList=[{
			"productId":me.purchaseObj.productId,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
			}]
	

		var opsCart = Object.assign({}, formData, { productList: JSON.stringify(productList) });
		var submitFormFields = opsCart;
		var paymentSubmitElem = $('#doPayForm');
		me.fillForm(paymentSubmitElem, submitFormFields);
		
		$.ajax({
			url: this.getUrlFor("OPS_FORM_VALIDATION"),
			data: $(paymentSubmitElem).serializeArray(),
			type: 'POST',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){
				if(response !== null){
					if(response.formValid){
						me.setState({serverMessage:''});
	    					//me.doPay();
	    					me.showOrderReview();
	    				}				
	    				else if(response.errorMsgs != null){
	    					var errmsg = "";								
	    					if(response.fieldErrMap != null){
	    						for(var key in response.fieldErrMap){
	    							var msg = paymentErrorMap[response.fieldErrMap[key].split(":")[0]];		              
	    							errmsg += key +" : " + msg;
	    						}
	    					}
	    					me.setState({serverMessage:errmsg});

	    				}else{
	    					me.setState({serverMessage:'Sorry, we\'re unable to process your registration. Please try again later.'});
	    				}
	    			}

	    			//console.log("response : ", response);
	    		},
	    		error: function(response){
	    			console.log("Error in OPS_FORM_VALIDATION");
	    		}
	    	});

	}

    doPay(){
		var me =this;
        me.userId = me.getUser().getUserId();
		var payloadStr = JSON.stringify(me.payload);
		this.trackMe();
		var formData = {
			userId:me.getUserId(),
			appName:me.purchaseObj.appName,
			_appId:me.purchaseObj.appId,
			sessionId:this.state.sessionId,
			fullName:this.state.billing_name,					
			address:this.state.billing_address,					
			zip:this.state.billing_zipcode,					
			city:this.state.billing_city,					
			state:this.state.billing_state, 					
			countryCode:this.state.selectedCountryOption.value || "",				
			country:this.state.selectedCountryOption.label || "",	
			email:this.state.billing_email,
			phone:this.state.billing_phone,
			billingAddressLine1:this.state.billing_address,					
			billingAddressLine2:this.state.billing_address,	
			language:"EN", 
			currency:me.purchaseObj.currency,
			payload: payloadStr					
		}
		
		var productList=[{
			"productId":me.purchaseObj.productId,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
		}];

		
		var opsCart = Object.assign({}, formData, { productList: JSON.stringify(productList) });
		var submitFormFields = opsCart;
		var paymentSubmitElem = $('#doPayForm');
		me.fillForm(paymentSubmitElem, submitFormFields);
		$("#paySubmit").trigger("click");
		
		try{
			
			var gradeName = (me.purchaseObj.gradeName).toLowerCase().replace(/\s/g,'') || '';
			var productName = (me.purchaseObj.productName).toLowerCase().replace(/\s/g,'') || '';
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":gradeName+"-"+productName+"-purchased"});
		}catch(e){
			console.error(e);
		}
		
		return;
		
		//new HmAjax(this.getUrlFor("OPS_DO_PAY"),fd,headers).post(callBackSuccess,callBackFailure);
	}

    getUserId(){
        return this.getUser().getUserId();
    }

    getOPSHome(){
        var me =this;
        
		//console.log(me.productsJson,me.purchaseObj.tarrrifid,me.purchaseObj.productid);
		//console.log(me.productsJson[me.purchaseObj.productid]);
        
		if(me.purchaseObj){
            
			//IMPORTANT: This component needs to be extended to make the following parameters dynamic
			var formData = {				
			appName:me.purchaseObj.appName,
			_appId:me.purchaseObj.appId,
			sFrame: me.getUrlFor("PAYMENT_SUCCESS_URL"),
			fFrame: me.getUrlFor("PAYMENT_FAILURE_URL"),
			pcsUrl: me.getUrlFor("PAYMENT_PCS_URL"),
			pcfUrl: me.getUrlFor("PAYMENT_PCF_URL"),
			currency: me.purchaseObj.currency					
		}
		var productList=[{
			"productId":me.purchaseObj.productId,
			"productCategory":me.purchaseObj.productCategory,
			"price":me.purchaseObj.productPrice,
			"currency":me.purchaseObj.currency,
			"validity":me.purchaseObj.validity,
			"tariffId":me.purchaseObj.productTariffID,
			"count":1
		}];
		
		
		var opsCart = Object.assign({}, formData, { productList: JSON.stringify(productList) });
		
		var me = this;
			
		$.ajax({
			url: this.getUrlFor("OPS_PROCESSPAY"),
			data: opsCart,
			type: 'POST',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){
            	if(response != null){	    				
                        //alert("sessionid="+response.sessionId)
                        me.setSessionId(response.sessionId);
	    				
	    				if (response.currency) {    		           

	    					if(response.allTaxRules && response.allTaxRules.length > 0){
	    						for(var i=0; i<response.allTaxRules.length; i++){
	    							var tempObj = {};
	    							if(me.taxRules[response.allTaxRules[i].geo]){
	    								tempObj = me.taxRules[response.allTaxRules[i].geo];
	    							}
	    							tempObj[response.allTaxRules[i].currency] = response.allTaxRules[i];

	    							me.taxRules[response.allTaxRules[i].geo] = tempObj;
	    						}
	    					}
                            
	    					me.setState({sessionId:response.sessionId,opsReady:true,opsCheckDone:true});
	    					me.updatePrice();
	    				} else {
	    					me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});    		           

	    				}
	    				
	    			}	    	
	    			//console.log("response : ", response);
	    		},
	    		error: function(response){
	    			console.log("Error in OPS_PROCESSPAY");
	    			me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});    		     
	    		}
	    	});
		}
		//new HmAjax(this.getUrlFor("OPS_PROCESSPAY"),opsCart,headers).post(callBackSuccess,callBackFailure);
    }
    
    getOrderReview(){
        var me=this;
        //console.warn("tchr products review",this.purchaseObj.basePrice);
        
		var reviewData = {	
			userId:me.getUserId(),
			fullName:me.state.billing_name,					
			address:me.state.billing_address,					
			zip:me.state.billing_zipcode,					
			city:me.state.billing_city,					
			state:me.state.billing_state,
			country:me.state.selectedCountryOption.label || "",						
			phone:me.state.billing_phone,		
			email:me.state.billing_email,
			billingAddressLine1:me.state.billing_address,					
			billingAddressLine2:me.state.billing_address,	
			currency:me.purchaseObj.currency,
			validity:(me.purchaseObj.validity	== "365") ? "1 Year" : me.purchaseObj.validity,
			productName:me.purchaseObj.productName,
			price:me.purchaseObj.productPrice,
			taxAmount:me.state.taxAmount,
			totalAmount:me.state.prod_price,
			basePrice:me.state.basePrice ||  me.purchaseObj.basePrice, 
			otherCharges:me.state.otherCharges,
			selectedProductCategoryType:me.purchaseObj.productCategory,
			selectedProductCategoryTypeGA:me.purchaseObj.productCategory+"-GA",
			selectedProductClassName:me.purchaseObj.gradeName
        }
        

        return(
            <TchrOrderReview hideReviewModal={this.hideReviewModal} reviewData={reviewData} proceedPay={this.proceedPay}/>
            );
    }

      
    handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) { 
			this.submitForm();  
		}
		//this.showOrderReview();
	}

    render(){
        return (
            super.render()
        )
    }

}


// WEBPACK FOOTER //
// ./src/views/purchase/TchrBillingForm.js